<template>
<div class="d-flex h-100 w-100 justify-content-center projectlistboard-container">
  <div class="card projectlistboard-panel w-100">

    <div class="nav-outer-wrapper">
      <b-navbar toggleable="md" type="dark" class="primaryNav">
        <b-navbar-brand><img src="../../assets/kegs-logo-sml.png" v-b-tooltip.hover title="KEGS Field Developer"></b-navbar-brand>
          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          <!--START FIRST NAV SECTION (MAIN TOOLSET) -->
          <b-collapse is-nav id="nav_collapse">
            <span id="projectlistboard-title">Project List</span>
          </b-collapse>
          <b-navbar-nav class="my-0 right-nav-btns">
            <b-nav-item>
              <b-button v-b-tooltip.hover.bottom title="User Menu"
                @click="toggleRightMenu"
                class="showRight nav-link user-menu-button bg-inverse">
                  <span class="menu-icon">
                    <icon name="bars"></icon>
                  </span></b-button>
            </b-nav-item>
          </b-navbar-nav>
      </b-navbar>
    </div>

    <div id="project-table-container" class="container">
      <b-row>
        <b-col>
          <b-table outlined :items="dummyProjects" :fields="fields">

            <template class="text-center" slot="project_name" slot-scope="data">
              <a v-b-tooltip.hover title='Edit in project management' href="#" @click="openProjectManagment(data.item.workpack_id)">{{data.value}}</a>
            </template>

            <template class="text-center" slot="mobile_enabled" slot-scope="data">
              <span v-if="data.value">
                <icon name="check" scale=".8" ></icon>
              </span>
              <span v-else>
                <icon name="times"></icon>
              </span>
            </template>

            <template class="text-center" slot="dashboard" slot-scope="data">
              <a v-b-tooltip.hover title='Open project in dashboard' href="#" @click="openDashboard(data.item.workpack_id)">link</a>
            </template>

            <template class="text-center" slot="map" slot-scope="data">
              <a v-b-tooltip.hover title='Open project in map' href="#" @click="openMap(data.item.workpack_id)">link</a>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
  </div>
</div>
</template>
<script>
import 'vue-awesome/icons/plus'
import Vue from 'vue'
import store from '../../store'

export default {
  name: 'project-board-list',
  data() {
    return {
      dummyProjects: [{
          id: 1,
          project_name: 'Layla',
          client: 'x',
          last_updated: 'Today',
          mobile_enabled: true,
          workpack_id: 14,
          project_type: 'Construction'
        },
        {
          id: 2,
          project_name: 'BN10',
          client: 'z',
          last_updated: 'Today',
          mobile_enabled: true,
          workpack_id: 12,
          project_type: 'Concept'
        },
        {
          id: 3,
          project_name: 'Construction Progress Dashboard',
          client: 'y',
          last_updated: 'Yesterday',
          mobile_enabled: false,
          workpack_id: 15,
          project_type: 'Construction'
        },
        {
          id: 4,
          project_name: 'Alfredson',
          client: 'y',
          last_updated: 'Last Week',
          mobile_enabled: true,
          workpack_id: 11,
          project_type: 'Concept'
        },
        {
          id: 5,
          project_name: 'Westside',
          client: 'y',
          last_updated: 'Last Month',
          mobile_enabled: false,
          workpack_id: 6,
          project_type: 'Concept'
        },
        {
          id: 6,
          project_name: 'Origin',
          client: 'y',
          last_updated: 'Last Month',
          mobile_enabled: false,
          workpack_id: 10,
          project_type: 'Concept'
        }
      ],
      fields: [{
          key: 'project_name',
          label: 'Project Name'
        },
        {
          key: 'client',
          label: 'Client'
        },
        {
          key: 'last_updated',
          label: 'Last Updated'
        },
        {
          key: 'mobile_enabled',
          label: 'Mobile Enabled'
        },
        {
          key: 'project_type',
          label: 'Project Type'
        },
        {
          key: 'dashboard',
          label: 'Dashboard'
        },
        {
          key: 'map',
          label: 'Map'
        }
      ]
    }
  },
  computed: {
    menuRightCls: {
      get() {
        return this.$store.getters['user/menuRightCls']
      },
      set(val) {
        this.$store.commit('user/menuRightCls', val)
      }
    },
  },
  methods: {
    toggleRightMenu() {
      this.showProjectList = false
      this.menuRightCls = this.menuRightCls !== '' ? '' : 'spmenu-open'
    },
    openDashboard (val) {
      this.$router.push(`/dashboard/${val}`)
    },
    openMap (val) {
      this.$router.push(`/${val}`)
    },
    openProjectManagment (val) {
      this.$router.push(`/project-management/${val}`)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projectboard/ProjectListBoard.vue